import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./StoryControls.css";
import "./StoryImageMatchRound.css";
import "./StoryPagePanel.css";
import StoryMatchPickFeedback from "./StoryMatchPickFeedback";
import { faArrowRight, faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";
import type { ImageMatchGamePages, Page } from "../models/story";

type Props = {
  imageMatchPages: ImageMatchGamePages;
  showImageMatchResults: boolean;
  imageMatchClickedPage: Page | undefined;
  showPlayAgainButton: boolean;
  onPickImage: (page: Page) => void;
  onPlayAgain: () => void;
  onMinimize: () => void;
};

/**
 * Post-read game: sentence at top, pick the matching illustration.
 */
const StoryImageMatchRound = (props: Props) => {
  const {
    imageMatchPages,
    showImageMatchResults,
    imageMatchClickedPage,
    showPlayAgainButton,
    onPickImage,
    onPlayAgain,
    onMinimize,
  } = props;

  return (
    <>
      <p className="StoryPageText">{imageMatchPages.correctPage.text}</p>
      <p className="StoryMatchInstruction">
        Pick the image that matches this page of the story
      </p>
      <div className="StoryMatchImages">
        {imageMatchPages.allPages.map((page) => {
          const isCorrect = page === imageMatchPages.correctPage;
          const showCorrectOverlay =
            showImageMatchResults && isCorrect;
          const showWrongOverlay =
            showImageMatchResults &&
            page === imageMatchClickedPage &&
            !isCorrect;
          return (
            <div className="StoryMatchImage" key={page.image}>
              <div
                className="StoryMatchImageFrame"
                style={{
                  aspectRatio: page.aspectRatio ?? "1 / 1",
                }}
              >
                <img
                  className="StoryMatchImageImg"
                  src={page.image}
                  alt=""
                  onClick={() => onPickImage(page)}
                />
                {showCorrectOverlay && (
                  <StoryMatchPickFeedback variant="correct" />
                )}
                {showWrongOverlay && (
                  <StoryMatchPickFeedback variant="wrong" />
                )}
              </div>
            </div>
          );
        })}
      </div>
      {showPlayAgainButton && (
        <div className="StoryControls">
          <div />
          <button type="button" className="btn btn-link" onClick={onMinimize}>
            Use Playmat <FontAwesomeIcon icon={faArrowCircleDown} />
          </button>
          <button type="button" className="btn btn-primary" onClick={onPlayAgain}>
            Play Again! <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>
      )}
    </>
  );
};

export default StoryImageMatchRound;
